import React from "react";
import ResourceStore from "../stores/resource-store";
import AccessCodesStore from "../stores/access-codes-store";
import UserStore from "../stores/user-store";
import Dispatcher from "../dispatcher";
import Ancillaries from "./ancillaries";
import AccessCodes from "./access-codes";
import { VstTabs } from "vstui";

export default class ResourcesContainer extends React.Component {
  constructor() {
    super();
    this.state = {
      resources: ResourceStore.getAll(),
      user: UserStore.get(),
    };

    this._handleResourceChange = this._handleResourceChange.bind(this);
    this._handleUserChange = this._handleUserChange.bind(this);
  }

  componentDidMount() {
    Dispatcher.on(Dispatcher.RESOURCE_STORE_CHANGE, this._handleResourceChange);
    Dispatcher.on(Dispatcher.USER_STORE_CHANGE, this._handleUserChange);
  }

  componentWillUnmount() {
    Dispatcher.removeListener(
      Dispatcher.RESOURCE_STORE_CHANGE,
      this._handleResourceChange
    );
    Dispatcher.removeListener(
      Dispatcher.USER_STORE_CHANGE,
      this._handleUserChange
    );
  }

  _handleResourceChange() {
    this.setState({ resources: ResourceStore.getAll() });
  }

  _handleUserChange() {
    this.setState({ user: UserStore.get() });
  }

  _clickTab(e) {
    Routes.setRoute(`resources/${e.currentTarget.dataset.key}`);
  }

  _getTotalAncillaryCount() {
    if (!this.state.resources) {
      return 0;
    }
    return this.state.resources.reduce(
      (acc, item) => (item.ancillariesCount > 0 ? acc + 1 : acc),
      0
    );
  }

  _getTotalAccessCodeCount() {
    if (!this.state.resources) {
      return 0;
    }
    return this.state.resources.reduce(
      (acc, item) =>
        acc.accessCodeCount || item.accessCodeCount > 0 ? acc + 1 : acc,
      0
    );
  }

  render() {
    return (
      <div className="page resources">
        <h1>{i18n.t("base.resources")}</h1>
        <VstTabs activeIndex={this.props.activeIndex}>
          <VstTabs.Bar>
            <VstTabs.Tab href="#/resources/ancillaries">
              {i18n.t("resources.ancillaries")}{" "}
              <span>({this._getTotalAncillaryCount()})</span>
            </VstTabs.Tab>
            <VstTabs.Tab href="#resources/access-codes">
              {i18n.t("resources.access-codes")}{" "}
              <span>({this._getTotalAccessCodeCount()})</span>
            </VstTabs.Tab>
          </VstTabs.Bar>
          <VstTabs.Panels>
            <div className="deck resource-list">
              <Ancillaries
                user={this.state.user}
                resources={this.state.resources}
              />
            </div>
            <AccessCodes user={this.state.user} />
          </VstTabs.Panels>
        </VstTabs>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/components/resources-container.jsx
 **/